module.exports = __webpack_public_path__ + "img/taiken1.8b105b95.jpg";